import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import fr from './fr/translation.json'

const resources = {
  fr: { translation: fr },
} as const

export type TSupportedLanguages = keyof typeof resources
export const supportedLanguages: TSupportedLanguages[] = ['fr']

i18n.use(initReactI18next).init({
  lng: 'fr', // default language
  resources,
  fallbackLng: 'fr',
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
  interpolation: {
    escapeValue: false,
  },
})
